import { List, ListItem, ListItemIcon, ListItemText, Typography } from '@alice-financial/pretext-ui'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import * as React from 'react'
import { useOrg } from '../../organization/useOrg'
import { ShiftSurvey } from '../../shifts/ShiftSurvey'

export const ShiftsStepTitle = 'Shift Scheduling'

export const ShiftsDescription = () => (
  <Typography variant="body2" color="text.secondary">
    Set up shift scheduling for your workforce
  </Typography>
)

// Wrapper component that uses the core shift scheduling components
export const ShiftsComponent = () => {
  const org = useOrg()

  if (!org) return null

  return <ShiftSurvey org={org} />
}

export const ShiftsInstructions = () => (
  <>
    <Typography variant="body2" color="text.secondary" gutterBottom>
      Like with your payroll system, Alice can connect to your shifts scheduling system to better keep track
      of your employees and their benefit eligibility.
    </Typography>
    <Typography variant="body2" color="text.secondary" gutterBottom>
      To get set up, you will need to create a user account with admin permissions.
    </Typography>

    <Typography variant="subtitle1" fontWeight="bold">
      Requirements
    </Typography>
    <List dense>
      <ListItem disableGutters>
        <ListItemIcon>
          <CheckCircleOutlineIcon fontSize="small" color="primary" />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography variant="body2">Login credentials for your shift scheduling provider</Typography>
          }
        />
      </ListItem>
    </List>
  </>
)
